<template>
<div :class="$style['delay']">
    <pt-sub-title title="延期交付">
    </pt-sub-title>

    <pt-form-item label="开始日期：" :labelWidth="labelWidth">
      {{billData.start_date}}
    </pt-form-item>
    <pt-form-item label="目标日期：" :labelWidth="labelWidth">
      {{billData.delivery_date}}
    </pt-form-item>
    <pt-form-item label="延期日期：" :labelWidth="labelWidth" :required="true">
      <el-date-picker  v-model="form.delayDate" type="date" placeholder="选择日期" data-vv-as="延期日期" v-validate="'required'"></el-date-picker>
    </pt-form-item>
    <pt-form-item label="延期原因：" :labelWidth="labelWidth" :required="true">
      <wt-selector :options="options" name="reason" data-vv-as="原因" v-validate="'required'" v-model="form.delayReason" :clearable="true" :allow-create="true" :filterable="true" @mousedown.stop.native @click.stop.native :props="reasonProps" :noDataText="'暂无选项，请您直接录入内容'"></wt-selector>
    </pt-form-item>
    <pt-form-item label="备注：" :labelWidth="labelWidth">
      <el-input placeholder="请填写备注" v-model="form.comment" type="textarea"></el-input>
    </pt-form-item>
</div>
</template>
<script>
import {
  validate
} from 'utils/validate'
export default {
  name: 'delay-dialog',
  props: {
    billData: {
      type: Object,
      default: ()=>{}
    },
  },
  data () {
    return {
      labelWidth:'100px',
      form:{

      },
      options:[
				'样品较多，正在进行中，需要延期',
				'缺失标准品或试剂',
				'仪器故障',
				'需要提供仪器配件、色谱柱等',
				'实验结果超标或不符合预期，需重新复测',
				'样品量不够，或样品本身不适用，需要重新寄样',
				'实验后发现方法不合适，需要客户重新提供方法',
				'未提供有效方法，实验需要时间摸索',
				'客户先确认电子数据结果，再进行后续实验或出原始记录',
				'实验员不能正常到岗，需要延期',
				'送至其他部门或外送，需要延期'
			],
      reasonProps: {
        label: 'name',
        value: 'id'
      },
    }
  },
  watch: {
   
  },
  methods: {
    formValidata () {
      return validate(this, this.form)
    }   
  }
}
</script>
<style module lang="less">
@import "~less/var";
.delay{
  :global
   .button-div{
    margin-top: 40px;
   }
}
</style>
